module.exports = __webpack_public_path__ + "img/depthMap-bermagui230.932ce634.png";